import React from "react";
import PropTypes from "prop-types";
import {
  CardContainer,
  PlanHeader,
  PlanIconContainer,
  PlanIcon,
  PlanTitle,
  PriceContainer,
  PriceRow,
  OriginalPrice,
  DiscountedRow,
  Price,
  PriceInterval,
  ValidityPeriod,
  AnnualBillingText
} from "./SubscriptionCard.styled";

/**
 * A card component for displaying subscription plan information
 */
const SubscriptionCard = ({
  planType,
  planName,
  price,
  originalPrice,
  interval = "/month",
  validityLabel,
  validityDate,
  isActive = false,
  durationDisplay = null,
  yearlyPrice = null
}) => {
  const iconMap = {
    premium: "P",
    essential: "E",
    prosuite: "Ps",
    free: "F",
  };

  // Convert price to number for calculations
  const priceValue = parseFloat(price) || 0;
  
  // Simply check if this is an annual subscription using durationDisplay
  const isAnnualSubscription = durationDisplay === "Annually";

  const renderPrices = () => {
    if (originalPrice) {
      // Render discounted price with original price side by side
      return (
        <PriceRow>
          <OriginalPrice>${originalPrice}</OriginalPrice>
          <DiscountedRow>
            <Price>${price}</Price>
            <PriceInterval>{interval}</PriceInterval>
          </DiscountedRow>
        </PriceRow>
      );
    }
    
    // Just render the regular price
    return (
      <DiscountedRow>
        <Price>${price}</Price>
        <PriceInterval>{interval}</PriceInterval>
      </DiscountedRow>
    );
  };

  return (
    <CardContainer active={isActive}>
      <PlanHeader>
        <PlanIconContainer type={planType}>
          <PlanIcon>{iconMap[planType] || planType.charAt(0)}</PlanIcon>
        </PlanIconContainer>
        <PlanTitle active={isActive}>
          {planName} {isAnnualSubscription ? "(Annual Subscription)" : "(Monthly Subscription)"}
        </PlanTitle>
      </PlanHeader>

      <PriceContainer>
        {renderPrices()}

        {isAnnualSubscription && price !== "0" && (
          <AnnualBillingText>
            ${yearlyPrice || (priceValue * 12).toFixed(2)} billed annually
          </AnnualBillingText>
        )}
        {validityDate && (
          <ValidityPeriod>
            {validityLabel} {validityDate}
          </ValidityPeriod>
        )}
      </PriceContainer>
    </CardContainer>
  );
};

SubscriptionCard.propTypes = {
  planType: PropTypes.string.isRequired,
  planName: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  originalPrice: PropTypes.string,
  interval: PropTypes.string,
  validityLabel: PropTypes.string.isRequired,
  validityDate: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  durationDisplay: PropTypes.string,
  yearlyPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default SubscriptionCard; 